import type * as React from 'react';

import { toLocaleDateString } from '../Intl';

/**
 * A Text component to format the given string date, or Date instance, with the Intl.DateTimeFormat API
 * or using a fallback for non-supported browsers.
 *
 * Used locale and options:
 * - locale: 'en-US'
 * - options: { year: 'numeric', month: 'short', day: '2-digit' }
 *
 * Example output with the predefined defaults:
 * - Jun 08, 2023
 *
 */
export function DatePrettyLocale(
    props: {
        value: Date | string;
        showTime?: boolean;
    } & React.ComponentProps<'span'>
): React.ReactElement {
    const { value, showTime, ...rest } = props;

    return <span {...rest}>{toLocaleDateString(value, showTime)}</span>;
}
